import React from "react";
import NestedMenu from "./NestedMenu";

const NestedMenuLink = ({ link, level, labels }) => {
	const { url, children = [], title, is_external: external } = link;
	const hasChildren = children?.length >= 1;
	const isHeading = url === "#";
	// blank heading title will be &nbsp;
	const isBlankHeading = link.title.trim() == false && link.url === "/";

	return (
		<li className={`nested-menu__item ${link.classes || ""} ${isHeading ? "is-heading" : ""} ${isBlankHeading ? 'is-heading--blank' : ''} ${hasChildren ? "has-children" : ""}`}>
			{isBlankHeading ? null : isHeading ? (
				<p className="nested-menu__item__heading">{title}</p>
			) : (
				<a href={url} target={external ? "_blank" : ""} className={`nested-menu__item__link${external ? "--external" : ""}`} rel="noreferrer">
					{title}
				</a>
			)}
			{hasChildren && NestedMenu({ items: children, level: level + 1, labels })}
		</li>
	);
};
export default NestedMenuLink;
